<template>
  <div class="min-h-screen bg-white text-slate-900">
    <slot />
  </div>
</template>
